import { Navigate, type RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ConsultancyLogin from "../pages/consultancy/login/page";
import ConsultancyRegister from "../pages/consultancy/register/page";
import ForgotPassword from "../pages/consultancy/forgot-password/page";
import ProtectedRoute from "../auth/ProtectedRoute";
import ModuleGuard from "../auth/ModuleGuard";
import Privacy from "../pages/privacy/page";
import Terms from "../pages/terms/page";
import Blog from "../pages/blog/page";
import Support from "../pages/support/page";
import Docs from "../pages/docs/page";
import DashboardHome from "../pages/dashboard/home/page";
import StudentsPage from "../pages/dashboard/students/page";
import StudentDetailPage from "../pages/dashboard/students/detail";
import LeadsPage from "../pages/dashboard/leads/page";
import AppointmentsPage from "../pages/dashboard/appointments/page";
import ActivityPage from "../pages/dashboard/activity/page";
import ReportsPage from "../pages/dashboard/reports/page";
import SubscriptionPage from "../pages/dashboard/subscription/page";
import SettingsPage from "../pages/dashboard/settings/page";
import TeamPage from "../pages/dashboard/team/page";
import InstitutionsPage from "../pages/dashboard/institutions/page";
import ApplicationsPage from "../pages/dashboard/applications/page";
import DocumentsPage from "../pages/dashboard/documents/page";
import FinancePage from "../pages/dashboard/finance/page";
import TasksPage from "../pages/dashboard/tasks/page";
import HRPage from "../pages/dashboard/hr/page";
import PayrollPage from "../pages/dashboard/payroll/page";
import AttendanceKioskPage from "../pages/dashboard/kiosk/page";
import VisaPage from "../pages/dashboard/visa/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/consultancy/login",
    element: <ConsultancyLogin />,
  },
  {
    path: "/consultancy/register",
    element: <ConsultancyRegister />,
  },
  {
    path: "/consultancy/forgot-password",
    element: <ForgotPassword />,
  },
  {
    path: "/privacy",
    element: <Privacy />,
  },
  {
    path: "/terms",
    element: <Terms />,
  },
  {
    path: "/blog",
    element: <Blog />,
  },
  {
    path: "/support",
    element: <Support />,
  },
  {
    path: "/docs",
    element: <Docs />,
  },
  {
    path: "/dashboard",
    element: <ProtectedRoute><DashboardHome /></ProtectedRoute>,
  },
  {
    path: "/dashboard/counselors",
    element: <ProtectedRoute><Navigate to="/dashboard/team" replace /></ProtectedRoute>,
  },
  {
    path: "/dashboard/students",
    element: <ProtectedRoute><ModuleGuard module="students"><StudentsPage /></ModuleGuard></ProtectedRoute>,
  },
  {
    path: "/dashboard/students/:id",
    element: <ProtectedRoute><ModuleGuard module="students"><StudentDetailPage /></ModuleGuard></ProtectedRoute>,
  },
  {
    path: "/dashboard/leads",
    element: <ProtectedRoute><ModuleGuard module="leads"><LeadsPage /></ModuleGuard></ProtectedRoute>,
  },
  {
    path: "/dashboard/appointments",
    element: <ProtectedRoute><ModuleGuard module="appointments"><AppointmentsPage /></ModuleGuard></ProtectedRoute>,
  },
  {
    path: "/dashboard/attendance",
    element: <ProtectedRoute><Navigate to="/dashboard/hr" replace /></ProtectedRoute>,
  },
  {
    path: "/dashboard/leaves",
    element: <ProtectedRoute><Navigate to="/dashboard/hr" replace /></ProtectedRoute>,
  },
  {
    path: "/dashboard/activity",
    element: <ProtectedRoute><ModuleGuard module="activity"><ActivityPage /></ModuleGuard></ProtectedRoute>,
  },
  {
    path: "/dashboard/reports",
    element: <ProtectedRoute><ModuleGuard module="reports"><ReportsPage /></ModuleGuard></ProtectedRoute>,
  },
  {
    path: "/dashboard/subscription",
    element: <ProtectedRoute><ModuleGuard module="subscription"><SubscriptionPage /></ModuleGuard></ProtectedRoute>,
  },
  {
    path: "/dashboard/visa",
    element: <ProtectedRoute><ModuleGuard module="visa"><VisaPage /></ModuleGuard></ProtectedRoute>,
  },
  {
    path: "/dashboard/hr",
    element: <ProtectedRoute><ModuleGuard module="hr"><HRPage /></ModuleGuard></ProtectedRoute>,
  },
  {
    path: "/dashboard/kiosk",
    element: <ProtectedRoute><ModuleGuard module="hr"><AttendanceKioskPage /></ModuleGuard></ProtectedRoute>,
  },
  {
    path: "/dashboard/payroll",
    element: <ProtectedRoute><ModuleGuard module="payroll"><PayrollPage /></ModuleGuard></ProtectedRoute>,
  },
  {
    path: "/dashboard/tasks",
    element: <ProtectedRoute><ModuleGuard module="tasks"><TasksPage /></ModuleGuard></ProtectedRoute>,
  },
  {
    path: "/dashboard/finance",
    element: <ProtectedRoute><ModuleGuard module="finance"><FinancePage /></ModuleGuard></ProtectedRoute>,
  },
  {
    path: "/dashboard/documents",
    element: <ProtectedRoute><ModuleGuard module="documents"><DocumentsPage /></ModuleGuard></ProtectedRoute>,
  },
  {
    path: "/dashboard/applications",
    element: <ProtectedRoute><ModuleGuard module="applications"><ApplicationsPage /></ModuleGuard></ProtectedRoute>,
  },
  {
    path: "/dashboard/institutions",
    element: <ProtectedRoute><ModuleGuard module="institutions"><InstitutionsPage /></ModuleGuard></ProtectedRoute>,
  },
  {
    path: "/dashboard/team",
    element: <ProtectedRoute><ModuleGuard module="team"><TeamPage /></ModuleGuard></ProtectedRoute>,
  },
  {
    path: "/dashboard/settings",
    element: <ProtectedRoute><SettingsPage /></ProtectedRoute>,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
